// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nprogress .bar{height:10px;background:#29d!important}#nprogress .spinner-icon{border-top-color:#29d;border-left-color:#29d}", ""]);
// Exports
module.exports = exports;
